import BaseComponent from '../../BaseComponent';
import {ComponentContext} from "../../IComponent";
import UploadedFileComponent from "../../shared/UploadedFileComponent";
import m from "mithril";

export default class CommentForm extends BaseComponent {

    private readonly uploadedFilesComponent: UploadedFileComponent;

    private mounted = false;

    constructor(
        $component: JQuery<HTMLElement>,
        context?: ComponentContext,
    ) {
        super($component, context);

        this.uploadedFilesComponent = new UploadedFileComponent;
    }

    public get $uploadedFilesComponent(): JQuery<HTMLElement> {
        return this.$component.find('[data-uploaded-files]');
    }


    public init (): void {
        this.$component.not('.send-event-binded').on('submit', e => {
            // Send & disable the form
            this.context?.naja?.uiHandler.submitForm(<HTMLFormElement>e.currentTarget);
            $(e.currentTarget).find(':input, button').attr('disabled', 'disabled');
        }).addClass('send-event-binded');

        const card = this.$component.closest('.card');

        // Comment inline editation
        const $commentBlockEditable = card.find('.comment-block .editable').not('.event-binded');
        // @ts-ignore
        $commentBlockEditable.inlineEdit();
        $commentBlockEditable.addClass('event-binded');

        // Put files into uploadFileComponent
        // use $component instead of direct file input to prevent file input swap collision from KeepFileInputValueExtension.ts
        this.$component.on('change', e => {
            const fileInput = e.target;
            if (!(fileInput instanceof HTMLInputElement)) {
                return;
            }
            if (!fileInput.files || fileInput.files.length === 0) {
                return;
            }

            this.uploadedFilesComponent.addFiles(Array.from(fileInput.files));
            this.$uploadedFilesComponent.get(0).style.display = '';
            fileInput.value = '';

            // Mount uploaded files component only if user intent to upload some files
            if (!this.mounted) {
                m.mount(this.$uploadedFilesComponent.get(0), this.uploadedFilesComponent)
                this.mounted = true;
            }
        });

        // Custom data submit on click
        this.$component.find('input[type="submit"]').on('click', async e => {
            e.preventDefault();
            e.stopImmediatePropagation();

            $(e.target).attr('disabled', 'disabled');
            const submitButton = <HTMLInputElement>e.currentTarget;
            try {
                await this.uploadedFilesComponent.send(submitButton.form, 'files[]', this.context.naja);
            } finally {
                $(e.target).removeAttr('disabled');
            }
        });

        // Stop standard submit
        this.$component.on('submit', e => {
            e.preventDefault();
            e.stopImmediatePropagation();
        });

        const textarea = this.$component.closest('.card').find('textarea').get(0);
        if (textarea && textarea.hasAttribute('data-autofocus')) {
            textarea.focus();
        }
    }

    public beforeRemove() {
        // unmount uploaded files component
        m.mount(this.$uploadedFilesComponent.get(0), null);
        this.mounted = false;
    }
}
